export default __webpack_public_path__ + "static/media/Strangler's Mask of Waning Dusk.ccf87a63.jpg";